/**
 * AW Collapse
 * Expand / collapse with CSS animation.
 *
 * Trigger:  [data-aw-collapse-trigger="<target-id>"]
 * Content:  id="<target-id>"  [data-aw-collapse-content]
 *
 * Collapsed state: class "aw-is-collapsed" (CSS handles animation via max-height)
 */

(function () {
  function initBtn(btn) {
    if (btn.dataset.awCollapseInit) return;
    btn.dataset.awCollapseInit = '1';

    const target = document.getElementById(btn.dataset.awCollapseTrigger);
    if (!target) return;

    // Sync initial state from aria-expanded
    if (btn.getAttribute('aria-expanded') === 'false') {
      target.classList.add('aw-is-collapsed');
    }

    btn.addEventListener('click', () => {
      const expanded = btn.getAttribute('aria-expanded') === 'true';
      btn.setAttribute('aria-expanded', String(!expanded));
      target.classList.toggle('aw-is-collapsed', expanded);
    });
  }

  function init() {
    document.querySelectorAll('[data-aw-collapse-trigger]').forEach(initBtn);
  }

  document.addEventListener('DOMContentLoaded', init);
  document.addEventListener('shopify:section:load', init);

  window.AW = window.AW || {};
  window.AW.collapse = { init: initBtn, initAll: init };
})();